import { createStore } from 'zustand/vanilla'

export type ScheduleMode = 'weekday' | 'saturday' | 'sunday'

interface DevState {
  panelOpen: boolean
  scheduleMode: ScheduleMode
  fakeLocation: { lat: number; lon: number } | null
  showFps: boolean
  setPanelOpen: (open: boolean) => void
  setScheduleMode: (mode: ScheduleMode) => void
  setFakeLocation: (loc: { lat: number; lon: number } | null) => void
  setShowFps: (show: boolean) => void
}

export function getCurrentScheduleMode(at: Date = new Date()): ScheduleMode {
  try {
    const dayStr = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      weekday: 'short',
    }).format(at)
    if (dayStr === 'Sat') return 'saturday'
    if (dayStr === 'Sun') return 'sunday'
    return 'weekday'
  } catch {
    const day = at.getDay()
    if (day === 6) return 'saturday'
    if (day === 0) return 'sunday'
    return 'weekday'
  }
}

export const useDevStore = createStore<DevState>((set) => ({
  panelOpen: false,
  scheduleMode: getCurrentScheduleMode(),
  fakeLocation: null,
  showFps: true,
  setPanelOpen: (open) => set({ panelOpen: open }),
  setScheduleMode: (mode) => set({ scheduleMode: mode }),
  setFakeLocation: (loc) => set({ fakeLocation: loc }),
  setShowFps: (show) => set({ showFps: show }),
}))
